function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  d: "M50,5A45,45,0,1,0,95,50,45,45,0,0,0,50,5Zm1.77686,21.03265a6.31722,6.31722,0,0,1,6.03369-4.65405,3.813,3.813,0,0,1,3.998,4.709,6.31717,6.31717,0,0,1-6.03369,4.654A3.813,3.813,0,0,1,51.77686,26.03265ZM61.86768,69.054A34.11751,34.11751,0,0,1,51.7373,77.21979c-5.38964,2.7381-11.40258,1.4414-10.28833-3.68421l5.57789-25.66c1.06152-4.88269-3.31641-4.41431-8.27149-1.56158a.49791.49791,0,0,1-.623-.756A34.11751,34.11751,0,0,1,48.2627,37.39227c5.38964-2.738,11.40258-1.44134,10.28857,3.68421l-5.57813,25.66c-1.06152,4.88269,3.31641,4.41425,8.27149,1.56152A.49791.49791,0,0,1,61.86768,69.054Z"
});

var SvgIconAbout = function SvgIconAbout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 100 125",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconAbout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-about.245b950e.svg";
export { ForwardRef as ReactComponent };